import { render, staticRenderFns } from "./SEOPageNameLookup.vue?vue&type=template&id=5d0cc24c&lang=pug"
import script from "./SEOPageNameLookup.vue?vue&type=script&lang=js"
export * from "./SEOPageNameLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports